import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { IMenuNodeResponse } from "../menu.dto";

export class GetMenuCarrierCommand extends IRequestCommand<
  Array<IMenuNodeResponse>,
  ErrorDetails,
  IGetMenuCarrierCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'magiisaccess/portal/{portal}/menu';
  public override setParameters(parameters: IGetMenuCarrierCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{portal}',
      parameters.portal
    );
  }
}

export interface IGetMenuCarrierCommandParameters
  extends ICommandParameters {
    portal: string;
}

export interface IGetMenuCarrierResponse
  extends IMenuNodeResponse {}
